import {EmptyObject} from './EmptyObject';

// https://github.com/microsoft/TypeScript/issues/29729
export type LiteralUnionAutocomplete<T extends U, U = string> = T | (U & EmptyObject);
